import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams, Navigate } from 'react-router-dom';
import { datamodelIdFromType, isPrimarySite } from '@helpers';
import { BodyWrapper, Header, MainWrapper, Loader } from '@components';
import { datamodelsQuery, siteQuery } from '@queries';
import { GlobalContext } from '@contexts';

// This page checks permisions before redirecting
export const InterstitialPage = () => {
  const { siteID } = useParams();
  const globals = useContext(GlobalContext);

  // get the datamodels list
  const { data: datamodelsData, isPending } = useQuery(datamodelsQuery());

  // get the datamodel ID for site custom fields
  const datamodelID = datamodelsData
    ? datamodelIdFromType(datamodelsData?.objects, 'site_custom_fields')
    : null;

  if (isPending) console.log('Loading...');
  else {
    if (globals.visible.sitePagesView) {
      // Redirect to Pages
      return <Navigate to={`/dashboard/sites/${siteID}/pages`} replace />;
    } else if (!globals.visible.sitePagesView && !!datamodelID) {
      // Redirect to Manage Content
      return (
        <Navigate to={`/dashboard/sites/${siteID}/custom_fields`} replace />
      );
    } else {
      console.log('something went wrong!');
      // Redirect to main Projects page
      return <Navigate to={`/dashboard/projects`} replace />;
    }
  }

  return (
    <>
      <Header />
      <BodyWrapper>
        <MainWrapper>
          {isPending && (
            <Loader className="sb-loader sb-loader-sidebar-search" />
          )}
          {!isPending && <p> Redirecting...</p>}
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
